import React, { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { greeting, settings } from "../../portfolio.js";
import "./FloatingNavbar.css";

const FloatingNavbar = ({ theme }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const link = settings.isSplash ? "/splash" : "/home";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { path: "/home", label: "Home" },
    { path: "/education", label: "Education" },
    { path: "/experience", label: "Experience" },
    { path: "/projects", label: "Projects" },
    { path: "/contact", label: "Contact Me" },
  ];

  // Determine if theme is dark based on body color
  const isDarkTheme =
    theme.body &&
    (theme.body.includes("#000") ||
      theme.body.includes("#1") ||
      theme.body.includes("#2") ||
      parseInt(theme.body.replace("#", ""), 16) < 0x888888);

  const navbarVars = {
    color: theme.text,
    "--navbar-bg": isDarkTheme
      ? "rgba(0, 0, 0, 0.65)"
      : "rgba(255, 255, 255, 0.9)",
    "--navbar-border": isDarkTheme
      ? "rgba(255, 255, 255, 0.08)"
      : "rgba(0, 0, 0, 0.06)",
    "--navbar-shadow": isDarkTheme
      ? "0 10px 30px rgba(0, 0, 0, 0.45)"
      : "0 10px 30px rgba(0, 0, 0, 0.15)",
    "--navbar-blur": "18px",
    "--navbar-highlight": theme.imageHighlight || "#6366f1",
    "--navbar-accent": theme.highlight || "rgba(99, 102, 241, 0.12)",
  };

  return (
    <nav
      className={`floating-navbar ${
        isScrolled ? "floating-navbar-scrolled" : ""
      }`}
      style={navbarVars}
    >
      <div className="floating-navbar-container">
        <Link
          to={link}
          className="floating-navbar-logo"
          onClick={closeMobileMenu}
        >
          <span
            className="floating-navbar-logo-bracket"
            style={{ color: theme.imageHighlight }}
          >
            &lt;
          </span>
          <span className="floating-navbar-logo-name">
            {greeting.logo_name}
          </span>
          <span
            className="floating-navbar-logo-bracket"
            style={{ color: theme.imageHighlight }}
          >
            /&gt;
          </span>
        </Link>

        <button
          className="floating-navbar-mobile-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span
            className={`floating-navbar-hamburger ${
              isMobileMenuOpen ? "floating-navbar-hamburger-open" : ""
            }`}
          >
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        <ul
          className={`floating-navbar-menu ${
            isMobileMenuOpen ? "floating-navbar-menu-open" : ""
          }`}
        >
          {navLinks.map((navLink) => {
            const isActive =
              location.pathname === navLink.path ||
              (navLink.path === "/home" && location.pathname === "/");
            return (
              <li key={navLink.path} className="floating-navbar-menu-item">
                <NavLink
                  to={navLink.path}
                  className={`floating-navbar-link ${
                    isActive ? "floating-navbar-link-active" : ""
                  }`}
                  onClick={closeMobileMenu}
                  style={{
                    "--theme-highlight":
                      theme.highlight || "rgba(99, 102, 241, 0.1)",
                    "--theme-image-highlight":
                      theme.imageHighlight || "#6366f1",
                  }}
                >
                  {navLink.label}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

export default FloatingNavbar;
